/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ChildrenInputs */

const en_entity_children = /** @type {(inputs: Entity_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Children`)
};

const de_entity_children = /** @type {(inputs: Entity_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinder`)
};

/**
* | output |
* | --- |
* | "Children" |
*
* @param {Entity_ChildrenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_children = /** @type {((inputs?: Entity_ChildrenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ChildrenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_children(inputs)
	return de_entity_children(inputs)
});